import {
    orgBillingTransferCandidatesSchema,
    orgBillingTransferRequestSchema,
} from "@common/dto/billing/org-billing-transfer-request.dto";
import {
    cancelOrgBillingTransferRequestBodySchema,
    initiateOrgBillingTransferRequestBodySchema,
    orgBillingTransferCandidatesQuerySchema,
    orgBillingTransferRequestPathParamsSchema,
} from "@common/schemas/domains/billing/org-billing-transfer-request.schema";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { initContract } from "@ts-rest/core";

const c = initContract();

export const orgBillingTransferRequestContract = c.router(
    {
        getCandidates: {
            path: "/candidates",
            method: "GET",
            query: orgBillingTransferCandidatesQuerySchema,
            responses: {
                200: orgBillingTransferCandidatesSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        initiate: {
            path: "/initiate",
            method: "POST",
            body: initiateOrgBillingTransferRequestBodySchema,
            responses: {
                201: orgBillingTransferRequestSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
                409: ErrorMessageSchema,
            },
        },
        cancel: {
            path: "/:requestId/cancel",
            method: "POST",
            pathParams: orgBillingTransferRequestPathParamsSchema,
            body: cancelOrgBillingTransferRequestBodySchema,
            responses: {
                200: orgBillingTransferRequestSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
                409: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/org-billing-transfer-requests",
    },
);
